import React from 'react';

const MaccsEvaluation = () => {

    return (
    <p>Evaluation: Under construction</p>
    );
};

export default MaccsEvaluation;